import { useCustomerAvatar } from "@expert/contentful/src/hooks";
import { getLogger } from "@expert/logging";
import { Avatar, Skeleton, Transition } from "@mantine/core";
import type { JSX } from "react";
import type { ChatTask } from "@/sdk/agent/chat";
import classes from "./avatar-styles.module.css";
import type { ChatVariantProps } from "./variants";

const logger = getLogger({ module: "ChatAvatar" });

interface ChatAvatarProps extends ChatVariantProps {
    sessionId: string;
    customerName: ChatTask["customerName"];
    avatarSize: number;
}

export const ChatAvatar = ({ sessionId, customerName, avatarSize, variant }: ChatAvatarProps): JSX.Element => {
    const chatAvatarUrl = useCustomerAvatar(sessionId);
    const showSkeleton = variant === "incoming";

    const onAvatarLoadError = () => {
        logger.warn({ chatAvatarUrl }, "chat avatar failed to load");
    };

    return (
        <Skeleton
            height={`${avatarSize}px`}
            visible={showSkeleton}
            circle={true}
            className={classes.chat_avatar_placeholder}
        >
            <Transition mounted={!showSkeleton} transition="fade-right" duration={400} timingFunction="ease">
                {(transitionStyle) => (
                    <Avatar
                        src={chatAvatarUrl}
                        size={avatarSize}
                        alt="avatar"
                        name={customerName.value}
                        className={classes.chat_avatar}
                        imageProps={{
                            onError: onAvatarLoadError,
                        }}
                        style={{ ...transitionStyle }}
                    />
                )}
            </Transition>
        </Skeleton>
    );
};
